import { ComponentType, Suspense, lazy } from 'react';
import type { DataRouteObject } from 'react-router';
import { Layout } from 'src/layout/main-layout';
import { LoadingScreen } from './components/loading-screen';
import { AuthGuard } from './components/guards/auth-guard';

const Loadable =
  <T extends object>(Component: ComponentType<T>): ComponentType<T> =>
  props => (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

const Login = Loadable(
  lazy(() =>
    import('./containers/auth/login').then(module => ({
      default: module.LoginContainer,
    })),
  ),
);

const ForgotPassword = Loadable(
  lazy(() =>
    import('./containers/auth/forgot-password').then(module => ({
      default: module.ForgotPasswordContainer,
    })),
  ),
);

const UpdatePassword = Loadable(
  lazy(() =>
    import('./containers/auth/update-password').then(module => ({
      default: module.UpdatePasswordContainer,
    })),
  ),
);

const SetUpPassword = Loadable(
  lazy(() =>
    import('./containers/auth/set-up-password').then(module => ({
      default: module.SetUpPasswordContainer,
    })),
  ),
);

// Not found page
const NotFound = Loadable(
  lazy(() =>
    import('./containers/not-found').then(module => ({
      default: module.NotFound,
    })),
  ),
);

const ChangePasswordContainer = Loadable(
  lazy(() =>
    import('./features/password/containers/change-password').then(module => ({
      default: module.default,
    })),
  ),
);

//Assigned to no sites page
const NoSitesAvailablePage = Loadable(
  lazy(() =>
    import('./containers/no-sites-available').then(module => ({
      default: module.NoSitesAvaialble,
    })),
  ),
);

const routes: DataRouteObject[] = [
  {
    id: 'login-container',
    path: 'login',
    children: [
      {
        id: 'login',
        index: true,
        element: <Login />,
      },
    ],
  },
  {
    id: 'forgot-password-container',
    path: 'forgot-password',
    children: [
      {
        id: 'forgot-password',
        index: true,
        element: <ForgotPassword />,
      },
    ],
  },
  {
    id: 'set-up-password-container',
    path: 'set-up-password',
    children: [
      {
        id: 'set-up-password',
        index: true,
        element: <SetUpPassword />,
      },
    ],
  },
  {
    id: 'reset-password-container',
    path: 'reset-password',
    children: [
      {
        id: 'reset-password',
        index: true,
        element: <UpdatePassword />,
      },
    ],
  },
  {
    id: 'not-found',
    path: '*',
    element: <NotFound />,
  },
  {
    id: 'no-sites-available',
    path: 'no-sites-available',
    element: <NoSitesAvailablePage />,
  },
  {
    id: 'password-container',
    path: 'password',
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      {
        id: 'password',
        index: true,
        element: <ChangePasswordContainer />,
      },
    ],
  },
];

export default routes;
